<template>
      <div class="modal fade" :id="modalId" ref="modalEl" tabindex="-1"  :aria-labelledby="`${modalId}-label`" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content preview-modal">
      <div class="modal-header">
        <div class="modal-title" :id="`${modalId}-label`">Applicant Preview</div>
          <button class="btn btn-default btn-sm close-btn" @click="handleClose">
            <CloseIcon/>
          </button>
      </div>
      <div class="modal-body preview-details">
        <div class="preview-info">
          <div class="applicant">
            <div class="profile">
              <UserProfileIcon style="height:2.3rem;" class="profile-icon"/>
              <div class="profile-details">
                <div class="fullname">{{applicant.fullname }}</div>
                <div class="details">{{ applicant.email }} &#x1F784; {{ applicant.phone }}</div>
              </div> 
            </div>
          
            <div v-if="applicant.isCalled || applicant.isInterviewed || applicant.hasPassed" class="progression">

              <div v-if="applicant.isCalled" class="progress-box">
                <CheckCircleIcon class="progress-icon"/>
                <div class="progress-text">
                Was called
                </div>
              </div>

               <div v-if="applicant.isInterviewed" class="progress-box">
                <CheckCircleIcon class="progress-icon"/>
                <div class="progress-text">
                  Was interviewed
                </div>
              </div>

               <div v-if="applicant.hasPassed" class="progress-box">
                <CheckCircleIcon class="progress-icon"/>
                <div class="progress-text">
                  Passed interviews
                </div>
              </div>

            </div>
          </div>
          <div class="prev-buttons">
             <button v-if="applicant.isShortlisted" @click="toggleShortlist" class="btn btn-default btn-sm prev-button">
              <UserUncheckIcon style="height:1rem;margin-right:0.3rem!important;" class="prev-icon"/> <div class="button-label">Remove From Shortlist</div>
            </button>
            <button v-else @click="toggleShortlist" class="btn btn-default btn-sm prev-button">
              <UserCheckIcon style="height:1rem;margin-right:0.3rem!important;" class="prev-icon"/> <div class="button-label">Add To Shortlist</div>
            </button>  
             <button v-if="applicant.usedPlatformCV" @click="getCVInformationAsync" :disabled="loading" class="btn btn-default btn-sm prev-button prev-outline">
              <FileIcon style="height:1rem;margin-right:0.1rem;margin-top:-0.05rem;" class="prev-icon"/> <div class="button-label">{{ loading == true ? 'Loading CV...':'Preview CV' }}</div>
            </button>
             <!-- <button @click="setForDelete" class="btn btn-default btn-sm prev-button red">
              <TrashIcon style="height:1rem;margin-right:0.1rem;margin-top:-0.05rem;" class="prev-icon"/> <div class="button-label">Delete</div>
            </button> -->
           
          </div>

          <div class="checkbox-area">
           <div class="form-check mb-2">
              <input class="form-check-input" v-model="cantFindDocs" type="checkbox" id="checkDefault">
              <label class="form-check-label" for="checkDefault">
                {{ pagecontent.applicantPreview.cantFindDocs }}
              </label>
            </div>
            <div v-if="cantFindDocs" class="description-before-button">
               {{ pagecontent.applicantPreview.cantFindDocsDescription }}
            </div>
             <button v-if="cantFindDocs" @click="requestDocumentsAsync" :disabled="requestLoading" class="btn btn-default btn-sm prev-button request-docs" style="width:12rem;">
              <ArrowUpRightIcon class="prev-icon"/> <div class="button-label">{{ requestLoading ? 'Sending Request...':'Request Documents' }}</div>
             </button>
             <div :class="requestSuccess ? 'small-message':'small-message message-red'">{{requestMessage}}</div>
          </div>
        </div>
        <div class="preview-cv">
                 <div v-if="!loading && error" class="no-cv-text">
                  Unable to pull Platform CV. Try again later
                </div>
                 <!-- <div v-if="!loading && !error && cvInformation != {}" class="no-cv-text">
                  {{ applicant.usedPlatformCV && !loading && !error && cvInformation != {} ? "Preview Platform CV Here" : "No Platform CV Attached" }}
                </div> -->
                <LoadingIndicator v-else-if="loading" message="Getting Platform CV"/> 
                <CVViewer v-if="!loading && !error && cvInformation != {}"/>
               
               
                
                   
        </div>
      </div>
      </div>
      
    </div>
  </div>
</template>
<script>
import { Modal } from 'bootstrap';
import CloseIcon from '../IconComponents/CloseIcon.vue';
import UserCheckIcon from '../IconComponents/UserCheckIcon.vue';
import ArrowUpRightIcon from '../IconComponents/ArrowUpRightIcon.vue';
import UserUncheckIcon from '../IconComponents/UserUncheckIcon.vue';
import TrashIcon from '../IconComponents/TrashIcon.vue';
import pagecontent from '../../assets/text.json';
import CVViewer from '@/views/ProfileView/CVViewer.vue';
import LoadingIndicator from '../Utility/LoadingIndicator.vue';
import CheckCircleIcon from '../IconComponents/CheckCircleIcon.vue';
import FileIcon from '../IconComponents/FileIcon.vue';
import { getCVFromApplicantAsync, RequestEmailedDocumentsAsync } from '@/services/cvbuilderService.js';
import UserProfileIcon from '../IconComponents/UserProfileIcon.vue';
export default {
  components:{
    CloseIcon,
    UserCheckIcon,
    ArrowUpRightIcon,
    TrashIcon,
    UserUncheckIcon,
    CVViewer,
    LoadingIndicator,
    CheckCircleIcon,
    FileIcon,
    UserProfileIcon
  },
    props:{
      applicant:{
        type: Object,
        required: true,
      },
        modalId:{
            type: String,
            required: true
        },
        toggleShortlist:{
          type: Function,
          required: true
        },
        setForDelete:{
          type: Function,
          required: true
        }
    },
    computed:{
      cvInformation(){
        return this.$store.getters['cvbuilder/getCVInformation'] || {}
      }
    },
    data(){
      return{
        pagecontent,
        cantFindDocs: false,
        platformCVAvailable: false,
        noCVMessage: "",
        loading: false,
        error: false,
        requestLoading: false,
        requestError: false,
        requestSuccess: false,
        requestMessage:""
      }
    },
  
     mounted() {
    this.modalInstance = new Modal(this.$refs.modalEl);
  },
    methods: {
      async getCVInformationAsync(){
        try{
        this.$store.dispatch('cvbuilder/loadCVInformation', {});
        this.loading = true;
        this.error = false;
        let response = await getCVFromApplicantAsync(this.applicant.applicantId,this.hide);
        if(!response.success){
          let err = new Error(response.message);
          throw err;
        }else{
          this.loading = false;
          this.error = false;
          this.$store.dispatch('cvbuilder/loadCVInformation', response.cv);
        }
       
        }catch(e){
            this.loading = false;
            this.error = true;
            this.noCVMessage = e.message || "Something went wrong. Please try later";           
        }
      },

      show() {
        this.modalInstance?.show();
      },
      hide() {
        this.cantFindDocs = false; //must uncheck cant find docs
         this.$store.dispatch('cvbuilder/loadCVInformation', {});
        this.modalInstance?.hide();
      }
      ,
      handleClose() {
        // Ensure the modal hides itself first, then call the parent's close handler
        this.hide();
        // if (typeof this.closeModal === 'function') {
        //   this.closeModal();
        // }
      },
      async requestDocumentsAsync(){
          try{
            this.requestMessage = "";
            this.requestLoading = true;
            this.requestError = false;
            this.requestSuccess = false;
            let jobInfo = sessionStorage.getItem("vacancyInfo");
            if(jobInfo == null){
              let err = new Error();
              throw err;
            }
            let vacancy = JSON.parse(jobInfo);
          let response = await RequestEmailedDocumentsAsync(this.applicant.email,vacancy.jobId,this.hide);
          if(!response.success){
            let err = new Error(response.message);
            throw err;
          }else{
            this.showRequestSuccess();
          }
        }catch(e){
          this.showRequestFailed();
        }
      },
      showRequestSuccess(){
        this.requestLoading = false;
        this.requestError = false;
        this.requestSuccess = true;
        this.requestMessage = "Your Documents Request has been sent.";
        this.cantFindDocs = false; //must uncheck cant find docs
        setTimeout(() => {
          this.requestLoading = false;
          this.requestError = false;
          this.requestSuccess = false;
          this.requestMessage = "";
        }, 5000);
      },
      showRequestFailed(){
        this.requestLoading = false;
        this.requestSuccess = false;
        this.requestError = true;
        this.requestMessage = "Unable to send Documents Request. Please try again.";
        this.cantFindDocs = false; //must uncheck cant find docs
        setTimeout(() => {
          this.requestLoading = false;
          this.requestError = false;
          this.requestSuccess = false;
          this.requestMessage = "";
        }, 5000)
      }
    }
}
</script>
<style scoped>

.request-docs:hover{
  color:white!important;
  background-color:var(--page-header)!important;
  border:0px!important;
}

.small-message{
  margin-top:0.8rem;
  /* font-size:0.8rem; */
  color:var(--green);
  font-family: var(--body-font-bold);
}

.message-red{
  color:var(--red)!important;
}

.profile{
  display:flex;
  column-gap:0.4rem;
}
.profile-icon{
  margin-top:0.2rem;
  color:var(--placeholder);
}

.modal-title{
  color:var(--page-header);
}

.prev-outline{
  background:transparent!important;
  color:var(--page-header)!important;
  border:0.1rem solid var(--page-header)!important;
  /* font-weight: bold; */
}

.preview-info{
  margin-left:1rem;
}

  .progression{
    margin-top:0.6rem;
    color:var(--page-header);
  }

  .progress-box{
    display: flex;
    margin-bottom:0.1rem;
    color:var(--sidenav-link);
   
  }

  .progress-icon{
    height:0.8rem;
    transform:translateY(0.2rem);
  }

  .progress-text{
    font-size:0.8rem;
  }



  input[type="checkbox"]:checked {
            background-color: var(--page-header)!important;
            border: 1px solid var(--page-header)!important;
        }


    .description-before-button{
      font-size:0.8rem;
      color:var(--grey);
      width:20rem;
      /* line-height:0.9rem; */
      margin-bottom:1rem;
    }

    .checkbox-area{
      margin-top:2rem;
    }

    .form-check-label{
      font-size:0.9rem;
      color: var(--page-header)!important;
      /* font-weight: bold; */
    }
    

    .prev-buttons{
      margin-top:1rem;
      display: flex;
      column-gap:0.4rem;
    }

    .prev-button{
      display: flex;
      align-items: center;
      color:var(--enterprise-button);
      background-color: var(--page-header);
      /* border-radius:100px; */
      padding:0.4rem 0.6rem;
    }

    .green{
      background-color: var(--green);
    }

    .red{
      color:var(--red);
      background: transparent;
    }

    .prev-icon{
      margin-top:0.1rem;
    }

    .fullname{
      font-family:var(--heading-font-bold);
      font-size:1.2rem;
      color:var(--page-header);
    }
    .preview-cv{
        display: grid;
        overflow-y: scroll;
        max-height:35rem;
    }

        /* Custom vertical scrollbar for WebKit browsers (Chrome, Edge, Safari) */
    .preview-cv::-webkit-scrollbar {
      width: 8px;
    }

    .preview-cv::-webkit-scrollbar-track {
      background: var(--list-item);
      border-radius: 4px;
    }

    .preview-cv::-webkit-scrollbar-thumb {
      background-color: var(--scrollbar-color);
      border-radius: 4px;
      border: 2px solid var(--list-item);
    }

    .preview-cv::-webkit-scrollbar-thumb:hover {
      background-color: var(--scrollbar-color);
    }

    .no-cv-text{
        color:var(--placeholder);
        font-family: var(--heading-font-bold);
        justify-self: center;
        margin-top:4rem;
    }

    .preview-details{
        display: grid;
        grid-template-columns: 1fr 1.4fr;
        grid-column:1rem;
    }
 
    .modal-content, .modal-footer{
        transform: translateX(-19rem);
    }
    .preview-modal, .modal-footer{
        width:70rem;
        
    }

    .modal-body{
        border-bottom-right-radius:8px;
        border-bottom-left-radius:8px;
        min-height: 80vh;
    }

    .modal-footer{
        border-top: 0px;
    }

  /* MODAL */
    .modal-body{
        color:var(--foreground);
    }

    .modal-header{
      border-bottom:0px;
    }
   
</style>